module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAABZUlEQVQ4jZ3TP0iVURgG8N/Vz5ZssSwIEiuzWXJo9yA0N+TSKDgkQQ1BuAgJYQROgaMOOvgHApe6X0ODmoM4WxDeVBpqsSBEKxvO+eDyIdxLL5zhvOc5z3ne93lPpVqtahCtmEMbbqZ1DV8ghACyRiz4g3u4jvW07y6IimiGCM5jC6MYRFcZ0NIEySV8x0vM4DJ+l0GNFHVgDxMYT7n7OEAfLuJNvaKQ5NdHO7bxAmN1+T38xC8s5Xk+VCh6hjvp4CFquIBlvMXTtG8tPVQTTVjJ87ySJWALZrGK97iVLi/gHc6cUvYJ1sT+zWWYSgTHGMBuKvM1bqTcFVRKRD9wG08wkuER7uID9hNoF/3irDwWHStHF+bxIIQwXbi2dArwG3rE5rbhecqfxRE6MRxCWKSx/fvoxUf8xaT4XWZEMzYLYDOT/QlX8TmpO8S5MqjZL7KTyDYSyav/IcowLZb2VZzmWhn0D6k5ULRmOScJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/15.png
// module id = EAOs
// module chunks = 0